import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: 'mat-label[required-aria]',
})
export class RequiredAriaDirective implements OnChanges {
  @Input('required-aria') isRequired: boolean;

  constructor(private el: ElementRef, private renderer: Renderer2) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.isRequired?.currentValue) {
      return;
    }
    this.renderer.setAttribute(this.el.nativeElement, 'aria-label', 'This is a required field');
    this.renderer.addClass(this.el.nativeElement, 'required');
  }
}
